import React from 'react';
import { Rate } from 'antd';
import PropTypes from 'prop-types';
import api from '../../../utils/api';
import { LocalizationContext } from '../../../hoc/Localization';
import { UserContext } from '../../../hoc/User';
import { SecurityContext } from '../../../hoc/Security';
import Button from '../../Button';
import TextArea from '../../Input/TextArea';
import styles from './styles.less';

const ReviewForm = ({ externalId, pushReview, id, type }) => {
  const [comment, setComment] = React.useState(null);
  const [notify, setNotify] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [rate, setRate] = React.useState(null);
  const { user } = React.useContext(UserContext);
  const { t } = React.useContext(LocalizationContext);
  const { review, setReview } = React.useContext(SecurityContext);

  const sendReview = async () => {
    if (!user) {
      setReview(true);
      return;
    }
    if (rate) {
      setLoading(true);

      const body = {
        school_rating: rate,
        school_id: externalId,
        id,
        type,
      };
      const courseBody = {
        course_rating: rate,
        course_id: externalId,
        id,
        type,
      };
      if (comment) {
        if (type === 'school') {
          body.comment = comment;
        } else {
          courseBody.comment = comment;
        }
      }

      try {
        if (type === 'school') {
          await api.post('/user-ratings/users/my-ratings', body);
          pushReview({ ...body, user, id: new Date(), type });
        } else {
          await api.post('/user-ratings/users/my-ratingsCourse', courseBody);
          pushReview({ ...courseBody, user, id: new Date(), type });
        }
        // eslint-disable-next-line
      } catch (e) {
      } finally {
        setLoading(false);
      }
    } else {
      setNotify(true);
    }
  };

  React.useEffect(() => {
    if (review && user) {
      sendReview();
      setReview(false);
    }
  }, [review, user]);

  return (
    <div className={styles.container}>
      <h2 className={styles.leaveReviewTitle}>{t('course.leave.reviews')}</h2>
      <TextArea
        placeholder={t('details.reviews.write')}
        className={styles.textarea}
        onChange={e => setComment(e.target.value)}
        value={comment}
      />
      <div className={styles.confirmRevewWrapper}>
        <div className={styles.buttons}>
          <div>
            <Button
              className={`review-submit-button ${styles.submitButton}`}
              type="primary"
              onClick={sendReview}
              loading={loading}
            >
              {t('addschool.confirm.submit')}
            </Button>
          </div>
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.rateContainer}>
            <span>{t('details.reviews.rate')}</span>
            <div className={styles.rate}>
              <Rate
                value={rate}
                onChange={value => {
                  if (notify) {
                    setNotify(false);
                  }
                  setRate(value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {notify ? <span className={styles.notify}>{t('details.reviews.value.0')}</span> : null}
    </div>
  );
};

ReviewForm.propTypes = {
  externalId: PropTypes.string.isRequired,
  pushReview: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.string,
};

ReviewForm.defaultProps = {
  id: '',
};

export default ReviewForm;
